import React, { useState } from 'react';
import { Box, VStack, Heading, Span, Button, Text, HStack } from '@bpba/ui-components';
import { useNavigate } from 'react-router-dom';
import { ADHESION_COMERCIOS_FORM } from '../Constantes';
import { Result } from './Result';
import { ResultError } from './ResultError';
import { SubmitHandler, useForm, Controller } from 'react-hook-form';
import { SpinnerCajas } from '../pages/Spinner/SpinnerCajas';
import RubrosOption from './fragments/Rubros';
import ComboSucursales from "./ComboSucursales";
import { Queries } from "../rest/Queries";
import { getLocalidadesCDNI } from '../rest/queries/getLocalidadesCDNI';
import { Localidad } from '../rest/models/Localidad';
import { AdhesionComerciosPersonaFisicaPersonaJuridicaModel } from '../rest/models/AdhesionComerciosPersonaFisicaPersonaJuridicaModel';
import { AdhesionComerciosPreSolicitudApiRQ } from '../rest/models/AdhesionComerciosPreSolicitudApiRQ';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useMutation, useQuery } from '@apollo/client';
import { Mutations } from '../rest/Mutations';
import { postAdhesionComerciosPreSolicitud } from '../rest/mutations/postAdhesionComerciosPreSolicitud';
import { getAdhesionComerciosDni } from "../rest/queries/getAdhesionComerciosDni";
import { useTurnstile } from 'react-turnstile';




type Props = {
    email: string
    cuit: number
    esCliente: boolean
    tipoPersona: number
    sucursalCliente?: number
    origenSolicitud: string
};

export const AdhesionComerciosPersonaFisica: React.FC<Props> = ({ email, cuit, esCliente, sucursalCliente, origenSolicitud, tipoPersona }: Props) => {


    const [errorServicio, setErrorServicio] = useState<boolean>(false);
    const [mensajeError, setMensajeError] = useState<React.ReactNode>();
    const navigate = useNavigate();
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [mensajeErrorPostProspecto, setMensajeErrorPostProspecto] = useState<string>("");
    const [servicioOk, setServicioOk] = useState<boolean>(false);
    const [nroSolicitud, setNroSolicitud] = useState(0);
    const [mensajeRtaServicio, setMensajeRtaServicio] = useState<React.ReactNode>();
    const REQUIRED_FIELD = "Campo requerido.";
    const mailValidator = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    const numberValidator = /^\d+$/;
    const [idProvinciaCDNI, setIdProvinciaCDNI] = useState<string>();
    const [adjuntar, setAdjuntar] = useState(false);
    const [vistaRenaper, setVistaRenaper] = useState(!esCliente);
    const [postAdhesionComerciosPreSolicitudApi, { loading: loadingMutation }] = useMutation<Mutations>(postAdhesionComerciosPreSolicitud);
    const [dni, setDni] = useState<number>();
    const [sexo, setSexo] = useState<string>();
    const [tramite, setTramite] = useState<number>();
    const [datosCopiados, setdatosCopiados] = useState<boolean>(false);
    const [vistaEmpresa, setVistaEmpresa] = useState<boolean>(false);
    const { data: { localidades } = {} } = useQuery<Queries>(getLocalidadesCDNI, { variables: { idProvincia: idProvinciaCDNI }, skip: !idProvinciaCDNI });
    const toknTurnstile = useTurnstile();


    const { register, handleSubmit, control, getValues, setValue, formState: { errors }, reset } = useForm<any>({
        mode: 'onChange',
        criteriaMode: 'all',
        reValidateMode: 'onChange',
        defaultValues: {
            genero: ""
        }
    });
    setValue("cuit", cuit);
    setValue("email", email);
    if (esCliente) {
        setValue("sucursal", sucursalCliente);
    }




    const onSubmit: SubmitHandler<AdhesionComerciosPersonaFisicaPersonaJuridicaModel> = async (data: AdhesionComerciosPersonaFisicaPersonaJuridicaModel) => {
        toknTurnstile.execute(document.getElementById('turnStileTkncontainer'), {
            sitekey: process.env.REACT_APP_TKN_SITEKEY!,
            callback: async (token: any) => {



                let datos: AdhesionComerciosPreSolicitudApiRQ = {
                    "googleToken": token,
                    "nombre": data.nombre,
                    "apellido": data.apellido,
                    "email": email,
                    "cuit": cuit,
                    "telefonoContacto": (data.telefonoArea + data.telefono).toString(),
                    "domicilioComercio": datosCopiados ? data.provinciaComercio?.split('-')[1] + "," + data.localidadComercio + "," + data.calleComercio + " " + data.numeroCalleComercio + "," + data.pisoComercio + "," + data.departamentoComercio + "," + data.codigoPostalComercio : data.provinciaComercio + "," + data.localidadComercio + "," + data.calleComercio + " " + data.numeroCalleComercio + "," + data.pisoComercio + "," + data.departamentoComercio + "," + data.codigoPostalComercio,
                    "sucursal": Number(data.sucursal),
                    "origenSolicitud": origenSolicitud === null ? "" : origenSolicitud,
                    "rubro": data.rubro,
                    "actividad": 1,
                    "datosTributarios": Number(data.datosTributarios)

                };



                if (!esCliente) {
                    datos.dni = Number(data.dni);
                    datos.domicilioLegal = adhesionComerciosDniVuelta?.provincia + ", " + adhesionComerciosDniVuelta?.municipio + ", " + adhesionComerciosDniVuelta?.calle + ", " + adhesionComerciosDniVuelta?.altura + ", " + adhesionComerciosDniVuelta?.codigoPostal;
                    datos.sexo = data.genero === "M" ? 2 : 1;
                    datos.fechaNacimiento = adhesionComerciosDniVuelta?.fechaNacimiento
                    datos.lugarNacimiento = data.lugarNacimiento
                    datos.nacionalidad = 93
                    datos.tipoPersona = tipoPersona
                    datos.estadoCivil = Number(data.estadoCivil)
                }


                if (vistaEmpresa) {
                    datos.datosApoderado = data.apoderadoNombre + " " + data.apoderadoApellido + ", " + data.apoderadoDni
                    datos.domicilioLegal = data.provincia?.split('-')[1] + "," + data.localidad + "," + data.calle + " " + data.numeroCalle + "," + data.piso + "," + data.departamento + "," + data.codigoPostal
                    datos.razonSocial = data.razonSocial
                    datos.estadoCivil = -1
                }
                postAdhesionComerciosPreSolicitudApi({ variables: { input: datos } }).then((response: any) => {


                    if (response.data?.AdhesionComerciosPreSolicitudApiRQ.resultado.toUpperCase() === "OK") {
                        setServicioOk(true);
                        setNroSolicitud(response.data?.AdhesionComerciosPreSolicitudApiRQ.nroSolicitud)
                        setAdjuntar(true)
                        setMensajeRtaServicio(<><Text fontSize={"20px"} margin={0} fontWeight={600}>A través de la opción “Adjuntar archivos”, podés enviar copia digitalizada de la documentación solicitada.</Text><Text fontSize={"16px"} margin={0}>Podrás cargar los siguientes formatos : image/gif, image/jpg, image/jpeg, image/png, txt, csv, bmp, tiff,pdf,docx  (tamaño máximo 1MB).</Text></>);

                    } else if (response.data.AdhesionComerciosPreSolicitudApiRQ.mensaje.includes("editarse")) {
                        setServicioOk(true);
                        setMensajeRtaServicio("Ya existe un registro con este cuit");
                    }
                    else {
                        setServicioOk(true);
                        setMensajeRtaServicio("Ha ocurrido un problema, inténtelo mas tarde.");
                    }

                }).catch(() => {
                    setServicioOk(true);
                    setMensajeErrorPostProspecto("Ha ocurrido un problema, inténtelo mas tarde.");
                });


            } 
        });
    }



    const { data: { adhesionComerciosDniVuelta } = {}, loading: loadingRenaper } = useQuery<Queries>(getAdhesionComerciosDni,
        {
            variables: { dni: dni, sexo: sexo, tramite: tramite }, skip: (!dni || !sexo || !tramite), onCompleted(data) {


                if (adhesionComerciosDniVuelta?.error == null) {

                    setValue("nombre", adhesionComerciosDniVuelta?.nombres)
                    setValue("apellido", adhesionComerciosDniVuelta?.apellido)
                    setValue("provincia", adhesionComerciosDniVuelta?.provincia)

                    setValue("localidad", adhesionComerciosDniVuelta?.municipio)
                    setValue("calle", adhesionComerciosDniVuelta?.calle)
                    setValue("numeroCalle", adhesionComerciosDniVuelta?.altura)
                    setValue("codigoPostal", adhesionComerciosDniVuelta?.codigoPostal)
                    setValue("lugarNacimiento", adhesionComerciosDniVuelta?.pais)
                    setVistaRenaper(false);

                } else {
                    setServicioOk(true);
                    setMensajeRtaServicio("Tuvimos un problema. Volvé a intentar más tarde y si el error continúa comunicate al 0810-666-0098");

                }



            }, onError() {
                setServicioOk(true);
                setMensajeRtaServicio("Tuvimos un problema. Volvé a intentar más tarde y si el error continúa comunicate al 0810-666-0098");

            }
        });

    function cargarRENAPER() {
        setDni(getValues("dni"));
        setSexo(getValues("genero"));
        setTramite(getValues("tramite"));
    }

    const copiarDatos = (e: any) => {

        if (e.target.checked) {
            setdatosCopiados(true)
            setValue("provinciaComercio", adhesionComerciosDniVuelta?.provincia)
            setValue("localidadComercio", adhesionComerciosDniVuelta?.municipio)
            setValue("calleComercio", adhesionComerciosDniVuelta?.calle)
            setValue("numeroCalleComercio", adhesionComerciosDniVuelta?.altura)
            setValue("codigoPostalComercio", adhesionComerciosDniVuelta?.codigoPostal)
        } else {
            setdatosCopiados(false)
            setValue("provinciaComercio", "")
            setValue("localidadComercio", "")
            setValue("calleComercio", "")
            setValue("numeroCalleComercio", "")
            setValue("codigoPostalComercio", "")
        }
    }


    function BuscLoc(formId: string) {
        setIdProvinciaCDNI(formId.split('-')[0]);
    }

    const handleRedirect = () => {
        navigate('/DocumentacionAdjunta', {
            state: {
                nroSolicitud: nroSolicitud,
                banner: ADHESION_COMERCIOS_FORM,
                titulo: "Adhesion comercios",
                masDeUnArchivo: true
            }
        });
    };
    const handleReset = () => {
        reset({});
        window.location.href = "/";
    };
    if (adjuntar) return (
        <VStack>
            <VStack>
                <Text fontSize={"22px"} lineHeight={"27px"} fontWeight={"400"} color={"primary.0"}>{mensajeRtaServicio}</Text>
                <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                    <VStack mr={"0.5rem"}>
                        <Button
                            onClick={() => handleReset()}
                            variant="secondary"
                            py={"10px !important"}
                            style={{
                                width: "100%",
                                height: "calc(1.8em + 0.75rem + 2px)"
                            }}
                        >
                            Finalizar
                        </Button>
                    </VStack>
                    <VStack mr={"0.5rem"}>
                        <Button
                            onClick={() => handleRedirect()}
                            variant="secondary"
                            py={"10px !important"}
                            style={{
                                width: "100%", backgroundColor: "white",
                                borderRadius: "3px 8px 3px 8px",
                                border: "solid 2px", borderColor: "#3c3c3b",
                                color: "#3c3c3b",
                                height: "calc(1.8em + 0.75rem + 2px)"
                            }}
                        >
                            Adjuntar archivos
                        </Button>
                    </VStack>
                </VStack>
            </VStack>

        </VStack>
    );

    if (loadingMutation || loadingRenaper) return <SpinnerCajas />;

    if (servicioOk) return (
        <Result handleReset={handleReset}>
            <VStack>
                <Heading level={2} fontWeight={400} children={mensajeRtaServicio} color="primary.0" tabIndex={0} />
            </VStack>
        </Result>

    );
    if (mensajeErrorPostProspecto !== "" && !servicioOk) return (
        <Result handleReset={handleReset}>
            <ResultError message={mensajeErrorPostProspecto}></ResultError>
        </Result>
    );



    return (

        <VStack>
            <Heading level={3} mb={'8px'} fontWeight={400} tabIndex={0}>Datos del Cliente</Heading>

            {errorServicio ?
                <VStack mt={"20px"}>
                    <Heading level={3} mb={'8px'} fontWeight={400} tabIndex={0}>
                        Datos Personales
                    </Heading>
                    <Span color="red" fontSize={"12px"} tabIndex={0}>
                        {mensajeError}
                    </Span>

                    <Button
                        onClick={() => handleReset()}
                        variant="secondary"
                        py={"10px !important"}
                    >
                        Volver
                    </Button>
                </VStack> :
                <></>}
            {vistaRenaper ?
                <form style={{ width: "100%" }} onSubmit={handleSubmit(cargarRENAPER)}>
                    <VStack mt={"20px"}>

                        <VStack >
                            <input type={"text"} {...register("dni", { required: REQUIRED_FIELD, minLength: { value: 8, message: "cantidad minima de caracteres: 8" }, maxLength: 8, pattern: { value: numberValidator, message: "El campo debe ser numérico" } })} name="dni" placeholder='DNI' maxLength={8} />
                            <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.dni ? "* " + errors.dni.message : ""}</Span>
                        </VStack>

                        <VStack mt={"20px"}>
                            <select tabIndex={0} aria-label={"Seleccione el genero"} {...register("genero", { required: REQUIRED_FIELD })} style={{ width: "100%" }} name="genero" placeholder='Seleccione género'>
                                <option value="">Seleccione género</option>
                                <option value="F">Femenino</option>
                                <option value="M">Masculino</option>
                            </select>
                            <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.genero ? "* " + errors.genero.message : ""}</Span>
                        </VStack>

                        <VStack mt={"20px"} marginBottom={"20px"}>
                            <input type={"text"} {...register("tramite", { required: REQUIRED_FIELD, maxLength: 11, minLength: { value: 11, message: "cantidad minima de caracteres: 11" }, pattern: { value: numberValidator, message: "El campo debe ser numérico" } })} name="tramite" placeholder="Nro de trámite DNI" maxLength={11} />
                            <Span fontSize={"12px"} tabIndex={0}>
                                *El número de trámite se encuentra al frente del documento, en la sección inferior al centro
                            </Span>
                            <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.tramite ? "* " + errors.tramite.message : ""}</Span>
                        </VStack>


                        <Button type="submit" variant="secondary" marginBottom={"24px"} style={{ height: "calc(1.8em + 0.75rem + 2px)" }} py={'10px !important'} >Enviar</Button>
                    </VStack>
                </form>
                :
                <Box>
                    <VStack>

                        {/*         /// no es cliente  */}

                        {!esCliente &&
                            <Box display={"flex"} justifyContent={"space-between"} mt={"20px"} mb={"10px"} height={"auto"}>
                                <VStack width={"50%"} minHeight={"60px"} justifyContent={"space-evenly"} style={{ cursor: "pointer" }} onClick={() => setVistaEmpresa(false)}>
                                    <Text textAlign={"center"} margin={0} color={vistaEmpresa ? "#ccc" : "#279d2e"} style={{ height: "80%", alignContent: "center" }}>Responsable inscripto</Text>
                                    <hr style={{ width: "90%", height: "5px", backgroundColor: vistaEmpresa ? "#ccc" : "#279d2e" }} />
                                </VStack>
                                <VStack width={"50%"} minHeight={"60px"} justifyContent={"space-evenly"} style={{ cursor: "pointer" }} onClick={() => setVistaEmpresa(true)}>
                                    <Text textAlign={"center"} margin={0} color={vistaEmpresa ? "#279d2e" : "#ccc"} style={{ height: "80%", alignContent: "center" }}>Empresa</Text>
                                    <hr style={{ width: "90%", height: "5px", backgroundColor: vistaEmpresa ? "#279d2e" : "#ccc" }} />
                                </VStack>
                            </Box>
                        }


                        <form onSubmit={handleSubmit(onSubmit)}>

                            <VStack>
                                <input type={"text"} tabIndex={0}
                                    {...register("cuit", {
                                        required: REQUIRED_FIELD, minLength: { value: 11, message: "cantidad minima de caracteres: 11" },
                                        maxLength: 11
                                    })}
                                    name='cuit' id='cuit' placeholder='CUIT ej: 30123456789' maxLength={11} minLength={11} disabled />

                            </VStack>
                            <VStack mt={"20px"} mb={"20px"}>
                                <input type={'text'} {...register("email", { required: REQUIRED_FIELD, pattern: { value: mailValidator, message: "Formato de email inválido ejemplo: juana@mail.com" } })} name="email" placeholder='E-mail' maxLength={100} disabled />
                            </VStack>

                            {vistaEmpresa &&
                                <VStack mb={"20px"}>
                                    <input tabIndex={0} {...register("razonSocial", { required: REQUIRED_FIELD, maxLength: 120 })} name="razonSocial" maxLength={120} type={"text"} placeholder="Razon social" />
                                    <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.razonSocial ? "* " + errors.razonSocial.message : ""}</Span>
                                </VStack>
                            }


                            {!esCliente &&
                                 <VStack mt={"20px"} mb={"20px"}>
                                    <Span color="primary.0" fontSize={"14px"} marginBottom={"8px"} style={{ lineHeight: "18px" }} tabIndex={0}>Consulta Renaper </Span>
                                    <Span fontSize={"14px"} style={{ width: "100%" }} tabIndex={0}>{adhesionComerciosDniVuelta?.nombres}- {adhesionComerciosDniVuelta?.apellido} - {dni} - {adhesionComerciosDniVuelta?.fechaNacimiento.slice(0, -9)} - {adhesionComerciosDniVuelta?.pais}</Span>
                                </VStack>
                            }


                            <Controller
                                control={control}
                                name="rubro"
                                rules={{ required: true }}
                                render={({ field }) => {
                                    return <RubrosOption {...field} onChangeValue={(e) => { field.onChange(e) }} />;
                                }}
                            />


                            <VStack mt={"20px"}>
                                <select tabIndex={0} {...register("datosTributarios", { required: REQUIRED_FIELD })} style={{ width: "100%" }} name="datosTributarios">
                                    <option value="">Seleccione datos tributarios</option>
                                    <option value="1">Responsable inscripto</option>
                                </select>
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.datosTributarios ? "* " + errors.datosTributarios.message : ""}</Span>
                            </VStack>


                            {!esCliente && !vistaEmpresa &&
                                <VStack mt={"20px"}>
                                    <select tabIndex={0} {...register("estadoCivil", { required: REQUIRED_FIELD })} style={{ width: "100%" }} name="estadoCivil">
                                        <option value="-1">Seleccione estado civil</option>
                                        <option value="1">Casado/a</option>
                                        <option value="2">Soltero/a</option>
                                        <option value="3">Viudo/a</option>
                                        <option value="4">Divorciado/a</option>
                                        <option value="5">Separado/a legal</option>
                                        <option value="6">Separado/a de hecho</option>
                                        <option value="7">Unido/a de hecho</option>
                                    </select>
                                    <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.estadoCivil ? "* " + errors.estadoCivil.message : ""}</Span>
                                </VStack>
                            }


                            {!vistaEmpresa &&
                                <VStack mt={"20px"}>
                                    <Span color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }}>
                                        Teléfono de contacto
                                    </Span>
                                    <VStack mt={"8px"} style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                        <VStack mr={"0.5rem"}>
                                            <input style={{ width: "100%" }} {...register("telefonoArea", { required: REQUIRED_FIELD, maxLength: 4, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="telefonoArea" placeholder='Ej.: 11' maxLength={4} type={"text"} />
                                            <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.telefonoArea ? "* " + errors.telefonoArea.message : ""}</Span>
                                        </VStack>
                                        <VStack>
                                            <input tabIndex={0} style={{ width: "100%" }} {...register("telefono", { required: REQUIRED_FIELD, maxLength: 14, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="telefono" placeholder='Ej.: 4232424' maxLength={14} type={"text"} />
                                            <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.telefono ? "* " + errors.telefono.message : ""}</Span>
                                        </VStack>
                                    </VStack>
                                </VStack>
                            }


                            {!esCliente ? <>
                                {vistaEmpresa ?
                                    <>


                                        <VStack mt={"20px"}>
                                            <Span color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }} >
                                                Datos del apoderado
                                            </Span>
                                            <Box mt={"8px"} mb={"20px"} justifyContent={'space-between'} display={'flex'} flexDirection={'row'}>


                                                <VStack mr={"0.5rem"}>
                                                    <input {...register(`apoderadoNombre`, { required: REQUIRED_FIELD, maxLength: 25 })} type="text" placeholder='Nombre del apoderado' maxLength={25} />
                                                    <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.apoderado && errors.apoderadoNombre ? "* " + errors.apoderadoNombre.message : ""}</Span>
                                                </VStack>
                                                <VStack >
                                                    <input {...register(`apoderadoApellido`, { required: REQUIRED_FIELD, maxLength: 25 })} type="text" placeholder='Apellido del apoderado' maxLength={25} />
                                                    <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.apoderado && errors.apoderadoApellido ? "* " + errors.apoderadoApellido.message : ""}</Span>
                                                </VStack>
                                            </Box>
                                            <VStack mr={"0.5rem"}>
                                                <input type={"text"}  {...register(`apoderadoDni`, { required: REQUIRED_FIELD, minLength: { value: 8, message: "cantidad minima de caracteres: 8" }, maxLength: 8, pattern: { value: numberValidator, message: "El campo debe ser numérico" } })} name="apoderadoDni" placeholder='DNI del apoderado' maxLength={8} />
                                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.apoderado && errors.apoderadoDni ? "* " + errors.apoderadoDni.message : ""}</Span>
                                            </VStack>
                                        </VStack>

                                        <VStack mt={"20px"}>
                                            <Span color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }}>
                                                Teléfono de contacto
                                            </Span>
                                            <VStack mt={"8px"} style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                                <VStack mr={"0.5rem"}>
                                                    <input style={{ width: "100%" }} {...register("telefonoArea", { required: REQUIRED_FIELD, maxLength: 4, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="telefonoArea" placeholder='Ej.: 11' maxLength={4} type={"text"} />
                                                    <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.telefonoArea ? "* " + errors.telefonoArea.message : ""}</Span>
                                                </VStack>
                                                <VStack>
                                                    <input tabIndex={0} style={{ width: "100%" }} {...register("telefono", { required: REQUIRED_FIELD, maxLength: 14, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="telefono" placeholder='Ej.: 4232424' maxLength={14} type={"text"} />
                                                    <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.telefono ? "* " + errors.telefono.message : ""}</Span>
                                                </VStack>
                                            </VStack>
                                        </VStack>


                                        <VStack mt={"20px"}>
                                            <Span color="primary.0" fontSize={"14px"} marginBottom={"8px"} style={{ lineHeight: "18px" }} tabIndex={0}>Domicilio legal </Span>
                                            <Span fontSize={"14px"} marginBottom={"8px"} style={{ lineHeight: "18px" }} tabIndex={0}>{adhesionComerciosDniVuelta?.ciudad} - {adhesionComerciosDniVuelta?.municipio} - {adhesionComerciosDniVuelta?.calle} - {adhesionComerciosDniVuelta?.altura}- {adhesionComerciosDniVuelta?.codigoPostal}</Span>

                                        </VStack>

                                        <HStack mt={"20px"}>
                                            <Span color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }} tabIndex={0}>Domicilio comercio </Span>
                                            <input type='checkbox' tabIndex={0} style={{ transform: "scale(1.1)", marginLeft: "10px", marginTop: "-5px" }}  {...register("check", { required: false })} onChange={(e) => copiarDatos(e)} />
                                            <Span ml={"8px"} color="secondary.1" fontSize={"14px"} style={{ lineHeight: "18px" }}>
                                                copiar direccion
                                            </Span>
                                        </HStack>

                                        {datosCopiados ?

                                            <VStack mt={"20px"}>

                                                <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                                    <VStack mr={"0.5rem"}>
                                                        <input tabIndex={0}{...register("provinciaComercio", { required: false })} name="provinciaComercio" placeholder='Provincia' type={"text"} disabled />
                                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.provinciaComercio?.message}</Span>
                                                    </VStack>
                                                    <VStack >
                                                        <input tabIndex={0}  {...register("localidadComercio", { required: false })} name="localidadComercio" placeholder='localidad comercio' type={"text"} disabled />
                                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.localidadComercio?.message}</Span>
                                                    </VStack>
                                                </VStack>
                                                <VStack mt={"20px"} mr={"0.5rem"}>
                                                    <input tabIndex={0} style={{ width: "100%" }} {...register("calleComercio", { required: REQUIRED_FIELD, maxLength: 50 })} name="calleComercio" placeholder='Calle' maxLength={50} type={"text"} disabled />
                                                    <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.calleComercio ? "* " + errors.calleComercio.message : ""}</Span>
                                                </VStack>
                                                <VStack mt={"20px"} style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>

                                                    <VStack mr={"0.5rem"}>
                                                        <input tabIndex={0} style={{ width: "100%" }} {...register("numeroCalleComercio", { required: REQUIRED_FIELD, maxLength: 5, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="numeroCalleComercio" placeholder='Nro' maxLength={5} type={"text"} disabled />
                                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.numeroCalleComercio ? "* " + errors.numeroCalleComercio.message : ""}</Span>
                                                    </VStack>
                                                    <VStack>
                                                        <input tabIndex={0} style={{ width: "100%" }} {...register("codigoPostalComercio", { required: REQUIRED_FIELD, maxLength: 8, })} name="codigoPostalComercio" placeholder='Codigo postal' maxLength={8} type={"text"} />
                                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.codigoPostalComercio?.message}</Span>
                                                    </VStack>
                                                </VStack>
                                                <HStack mt={"20px"} style={{ justifyContent: 'space-between', display: 'flex' }}>
                                                    <VStack mr={"0.5rem"}>
                                                        <input tabIndex={0} style={{ width: "100%" }} {...register("pisoComercio", { required: false, maxLength: 8, })} name="pisoComercio" placeholder='Piso' maxLength={8} type={"text"} />
                                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.pisoComercio?.message}</Span>
                                                    </VStack>
                                                    <VStack>
                                                        <input tabIndex={0} style={{ width: "100%" }} {...register("departamentoComercio", { required: false, maxLength: 8, })} name="departamentoComercio" placeholder='Departamento' maxLength={8} type={"text"} />
                                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.departamentoComercio?.message}</Span>
                                                    </VStack>

                                                </HStack>
                                            </VStack>

                                            :
                                            <VStack mt={"20px"}>


                                                <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                                    <VStack mr={"0.5rem"}>
                                                        <select tabIndex={0} aria-label={"Seleccione la provincia para la localidad"}
                                                            style={{ width: "100%" }}
                                                            {...register("provinciaComercio", { required: REQUIRED_FIELD })}
                                                            onChange={(e: any) => BuscLoc(e.target.value)} name="provinciaComercio" placeholder='Provincia' >
                                                            <option value="">Provincia</option>
                                                            <option value="2-Buenos Aires">Buenos Aires</option>
                                                            <option value="1-Ciudad de Buenos Aires">Ciudad de Buenos Aires</option>
                                                        </select>
                                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.provinciaComercio ? "* " + errors.provinciaComercio.message : ""}</Span>
                                                    </VStack>
                                                    <VStack >
                                                        <select tabIndex={0} aria-label={"Seleccione la localidad"} style={{ width: "100%" }} {...register("localidadComercio", { required: REQUIRED_FIELD })} name="localidadComercio" placeholder='Localidad comercio' >
                                                            <option value="">Localidad </option>
                                                            {localidades &&
                                                                localidades.map((item: Localidad) =>
                                                                    <option value={item.desc_localidad} key={item.desc_localidad}>{item.desc_localidad}</option>
                                                                )}
                                                        </select>
                                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.localidadComercio ? "* " + errors.localidadComercio.message : ""}</Span>
                                                    </VStack>
                                                </VStack>

                                                <VStack mt={"20px"} mr={"0.5rem"}>
                                                    <input tabIndex={0} style={{ width: "100%" }} {...register("calleComercio", { required: REQUIRED_FIELD, maxLength: 50 })} name="calleComercio" placeholder='Calle' maxLength={50} type={"text"} />
                                                    <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.calleComercio ? "* " + errors.calleComercio.message : ""}</Span>
                                                </VStack>
                                                <VStack mt={"20px"} style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>

                                                    <VStack mr={"0.5rem"}>
                                                        <input tabIndex={0} style={{ width: "100%" }} {...register("numeroCalleComercio", { required: REQUIRED_FIELD, maxLength: 5, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="numeroCalleComercio" placeholder='Nro' maxLength={5} type={"text"} />
                                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.numeroCalleComercio ? "* " + errors.numeroCalleComercio.message : ""}</Span>
                                                    </VStack>
                                                    <VStack>
                                                        <input tabIndex={0} style={{ width: "100%" }} {...register("codigoPostalComercio", { required: false, maxLength: 8, })} name="codigoPostalComercio" placeholder='Codigo postal' maxLength={8} type={"text"} />
                                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.codigoPostalComercio?.message}</Span>
                                                    </VStack>
                                                </VStack>
                                                <HStack mt={"20px"} style={{ justifyContent: 'space-between', display: 'flex' }}>
                                                    <VStack mr={"0.5rem"}>
                                                        <input tabIndex={0} style={{ width: "100%" }} {...register("pisoComercio", { required: false, maxLength: 8, })} name="pisoComercio" placeholder='Piso' maxLength={8} type={"text"} />
                                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.pisoComercio?.message}</Span>
                                                    </VStack>
                                                    <VStack>
                                                        <input tabIndex={0} style={{ width: "100%" }} {...register("departamentoComercio", { required: false, maxLength: 8, })} name="departamentoComercio" placeholder='Departamento' maxLength={8} type={"text"} />
                                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.departamentoComercio?.message}</Span>
                                                    </VStack>

                                                </HStack>




                                            </VStack>
                                        }

                                    </>

                                    :
                                    <>




                                        <VStack mt={"20px"}>
                                            <Span color="primary.0" fontSize={"14px"} marginBottom={"8px"} style={{ lineHeight: "18px" }} tabIndex={0}>Domicilio legal </Span>
                                            <Span fontSize={"14px"} marginBottom={"8px"} style={{ lineHeight: "18px" }} tabIndex={0}>{adhesionComerciosDniVuelta?.ciudad} - {adhesionComerciosDniVuelta?.municipio} - {adhesionComerciosDniVuelta?.calle} - {adhesionComerciosDniVuelta?.altura}- {adhesionComerciosDniVuelta?.codigoPostal}</Span>

                                        </VStack>

                                        <HStack mt={"20px"} >
                                            <Span color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }} tabIndex={0}>Domicilio comercio </Span>
                                            <input type='checkbox' tabIndex={0} style={{ transform: "scale(1.1)", marginLeft: "10px", marginTop: "-5px" }}  {...register("check", { required: false })} onChange={(e) => copiarDatos(e)} />
                                            <Span ml={"8px"} color="secondary.1" fontSize={"14px"} style={{ lineHeight: "18px" }}>
                                                copiar direccion
                                            </Span>
                                        </HStack>

                                        {datosCopiados ?

                                            <VStack mt={"20px"}>

                                                <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                                    <VStack mr={"0.5rem"}>
                                                        <input tabIndex={0}{...register("provinciaComercio", { required: false })} name="provinciaComercio" placeholder='Provincia' type={"text"} disabled />
                                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.provinciaComercio?.message}</Span>
                                                    </VStack>
                                                    <VStack >
                                                        <input tabIndex={0}  {...register("localidadComercio", { required: false })} name="localidadComercio" placeholder='localidad comercio' type={"text"} disabled />
                                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.localidadComercio?.message}</Span>
                                                    </VStack>
                                                </VStack>
                                                <VStack mt={"20px"} mr={"0.5rem"}>
                                                    <input tabIndex={0} style={{ width: "100%" }} {...register("calleComercio", { required: REQUIRED_FIELD, maxLength: 50 })} name="calleComercio" placeholder='Calle' maxLength={50} type={"text"} disabled />
                                                    <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.calleComercio ? "* " + errors.calleComercio.message : ""}</Span>
                                                </VStack>
                                                <VStack mt={"20px"} style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>

                                                    <VStack mr={"0.5rem"}>
                                                        <input tabIndex={0} style={{ width: "100%" }} {...register("numeroCalleComercio", { required: REQUIRED_FIELD, maxLength: 5, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="numeroCalleComercio" placeholder='Nro' maxLength={5} type={"text"} disabled />
                                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.numeroCalleComercio ? "* " + errors.numeroCalleComercio.message : ""}</Span>
                                                    </VStack>
                                                    <VStack>
                                                        <input tabIndex={0} style={{ width: "100%" }} {...register("codigoPostalComercio", { required: REQUIRED_FIELD, maxLength: 8, })} name="codigoPostalComercio" placeholder='Codigo postal' maxLength={8} type={"text"} />
                                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.codigoPostalComercio?.message}</Span>
                                                    </VStack>
                                                </VStack>
                                                <HStack mt={"20px"} style={{ justifyContent: 'space-between', display: 'flex' }}>
                                                    <VStack mr={"0.5rem"}>
                                                        <input tabIndex={0} style={{ width: "100%" }} {...register("pisoComercio", { required: false, maxLength: 8, })} name="pisoComercio" placeholder='Piso' maxLength={8} type={"text"} />
                                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.pisoComercio?.message}</Span>
                                                    </VStack>
                                                    <VStack>
                                                        <input tabIndex={0} style={{ width: "100%" }} {...register("departamentoComercio", { required: false, maxLength: 8, })} name="departamentoComercio" placeholder='Departamento' maxLength={8} type={"text"} />
                                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.departamentoComercio?.message}</Span>
                                                    </VStack>

                                                </HStack>
                                            </VStack>

                                            :
                                            <VStack mt={"20px"}>


                                                <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                                    <VStack mr={"0.5rem"}>
                                                        <select tabIndex={0} aria-label={"Seleccione la provincia para la localidad"}
                                                            style={{ width: "100%" }}
                                                            {...register("provinciaComercio", { required: REQUIRED_FIELD })}
                                                            onChange={(e: any) => BuscLoc(e.target.value)} name="provinciaComercio" placeholder='Provincia' >
                                                            <option value="">Provincia</option>
                                                            <option value="2-Buenos Aires">Buenos Aires</option>
                                                            <option value="1-Ciudad de Buenos Aires">Ciudad de Buenos Aires</option>
                                                        </select>
                                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.provinciaComercio ? "* " + errors.provinciaComercio.message : ""}</Span>
                                                    </VStack>
                                                    <VStack >
                                                        <select tabIndex={0} aria-label={"Seleccione la localidad"} style={{ width: "100%" }} {...register("localidadComercio", { required: REQUIRED_FIELD })} name="localidadComercio" placeholder='Localidad comercio' >
                                                            <option value="">Localidad </option>
                                                            {localidades &&
                                                                localidades.map((item: Localidad) =>
                                                                    <option value={item.desc_localidad} key={item.desc_localidad}>{item.desc_localidad}</option>
                                                                )}
                                                        </select>
                                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.localidadComercio ? "* " + errors.localidadComercio.message : ""}</Span>
                                                    </VStack>
                                                </VStack>

                                                <VStack mt={"20px"} mr={"0.5rem"}>
                                                    <input tabIndex={0} style={{ width: "100%" }} {...register("calleComercio", { required: REQUIRED_FIELD, maxLength: 50 })} name="calleComercio" placeholder='Calle' maxLength={50} type={"text"} />
                                                    <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.calleComercio ? "* " + errors.calleComercio.message : ""}</Span>
                                                </VStack>
                                                <VStack mt={"20px"} style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>

                                                    <VStack mr={"0.5rem"}>
                                                        <input tabIndex={0} style={{ width: "100%" }} {...register("numeroCalleComercio", { required: REQUIRED_FIELD, maxLength: 5, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="numeroCalleComercio" placeholder='Nro' maxLength={5} type={"text"} />
                                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.numeroCalleComercio ? "* " + errors.numeroCalleComercio.message : ""}</Span>
                                                    </VStack>
                                                    <VStack>
                                                        <input tabIndex={0} style={{ width: "100%" }} {...register("codigoPostalComercio", { required: false, maxLength: 8, })} name="codigoPostalComercio" placeholder='Codigo postal' maxLength={8} type={"text"} />
                                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.codigoPostalComercio?.message}</Span>
                                                    </VStack>
                                                </VStack>
                                                <HStack mt={"20px"} style={{ justifyContent: 'space-between', display: 'flex' }}>
                                                    <VStack mr={"0.5rem"}>
                                                        <input tabIndex={0} style={{ width: "100%" }} {...register("pisoComercio", { required: false, maxLength: 8, })} name="pisoComercio" placeholder='Piso' maxLength={8} type={"text"} />
                                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.pisoComercio?.message}</Span>
                                                    </VStack>
                                                    <VStack>
                                                        <input tabIndex={0} style={{ width: "100%" }} {...register("departamentoComercio", { required: false, maxLength: 8, })} name="departamentoComercio" placeholder='Departamento' maxLength={8} type={"text"} />
                                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.departamentoComercio?.message}</Span>
                                                    </VStack>

                                                </HStack>




                                            </VStack>
                                        }

                                    </>
                                }


                                {/* //fin no es cliente */}
                            </> :
                                <> {/* //es cliente */}


                                    <VStack mt={"20px"}>

                                        <Span color="primary.0" fontSize={"14px"} marginBottom={"8px"} style={{ lineHeight: "18px" }} tabIndex={0}>Domicilio comercio </Span>

                                        <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                            <VStack mr={"0.5rem"}>
                                                <select tabIndex={0} aria-label={"Seleccione la provincia para la localidad"}
                                                    style={{ width: "100%" }}
                                                    {...register("provinciaComercio", { required: REQUIRED_FIELD })}
                                                    onChange={(e: any) => BuscLoc(e.target.value)} name="provinciaComercio" placeholder='Provincia' >
                                                    <option value="">Provincia</option>
                                                    <option value="2-Buenos Aires">Buenos Aires</option>
                                                    <option value="1-Ciudad de Buenos Aires">Ciudad de Buenos Aires</option>
                                                </select>
                                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.provinciaComercio ? "* " + errors.provinciaComercio.message : ""}</Span>
                                            </VStack>
                                            <VStack >
                                                <select tabIndex={0} aria-label={"Seleccione la localidad"} style={{ width: "100%" }} {...register("localidadComercio", { required: REQUIRED_FIELD })} name="localidadComercio" placeholder='Localidad comercio' >
                                                    <option value="">Localidad </option>
                                                    {localidades &&
                                                        localidades.map((item: Localidad) =>
                                                            <option value={item.desc_localidad} key={item.desc_localidad}>{item.desc_localidad}</option>
                                                        )}
                                                </select>
                                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.localidadComercio ? "* " + errors.localidadComercio.message : ""}</Span>
                                            </VStack>
                                        </VStack>

                                        <VStack mt={"20px"} mr={"0.5rem"}>
                                            <input tabIndex={0} style={{ width: "100%" }} {...register("calleComercio", { required: REQUIRED_FIELD, maxLength: 50 })} name="calleComercio" placeholder='Calle' maxLength={50} type={"text"} />
                                            <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.calleComercio ? "* " + errors.calleComercio.message : ""}</Span>
                                        </VStack>
                                        <VStack  mt={"20px"} style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>

                                            <VStack mr={"0.5rem"}>
                                                <input tabIndex={0} style={{ width: "100%" }} {...register("numeroCalleComercio", { required: REQUIRED_FIELD, maxLength: 5, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="numeroCalleComercio" placeholder='Nro' maxLength={5} type={"text"} />
                                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.numeroCalleComercio ? "* " + errors.numeroCalleComercio.message : ""}</Span>
                                            </VStack>
                                            <VStack>
                                                <input tabIndex={0} style={{ width: "100%" }} {...register("codigoPostalComercio", { required: REQUIRED_FIELD, maxLength: 8, })} name="codigoPostalComercio" placeholder='Codigo postal' maxLength={8} type={"text"} />
                                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.codigoPostalComercio?.message}</Span>
                                            </VStack>
                                        </VStack>
                                        <HStack  mt={"20px"} style={{ justifyContent: 'space-between', display: 'flex' }}>
                                            <VStack mr={"0.5rem"}>
                                                <input tabIndex={0} style={{ width: "100%" }} {...register("pisoComercio", { required: false, maxLength: 8, })} name="pisoComercio" placeholder='Piso' maxLength={8} type={"text"} />
                                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.pisoComercio?.message}</Span>
                                            </VStack>
                                            <VStack>
                                                <input tabIndex={0} style={{ width: "100%" }} {...register("departamentoComercio", { required: false, maxLength: 8, })} name="departamentoComercio" placeholder='Departamento' maxLength={8} type={"text"} />
                                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.departamentoComercio?.message}</Span>
                                            </VStack>

                                        </HStack>

                                    </VStack>


                                </>

                            }


                            <Controller
                                control={control}
                                name="sucursal"
                                rules={{ required: true }}
                                render={({ field }) => {
                                    return <ComboSucursales {...field} onChangeValue={(e) => { field.onChange(e) }} titulo={"Sucursal cercana"} sucursalCliente={sucursalCliente} />
                                }}
                            />

                            <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.sucursal?.message}</Span>


                            <Button type="submit" variant="secondary" marginBottom={"24px"} style={{ height: "calc(1.8em + 0.75rem + 2px)" }} py={'10px !important'} >Enviar</Button>


                        </form>
                    </VStack>
                </Box>

            }
        </VStack>

    )

}



